import React, { useState, FC } from 'react';
import { useTranslation } from '@app/app/i18n';
import { Dialog, DialogContent, DialogClose, DialogTitle } from '@app/shared/ui/dialog';

type ResendConfirmAccountNotifyProps = {
  close: () => void;
  linkSended?: boolean | undefined;
};

const ResendConfirmAccountNotify: FC<ResendConfirmAccountNotifyProps> = (props) => {
  const { close, linkSended = false } = props;
  const { t } = useTranslation('common');

  const [linkSent, setLinkSent] = useState(linkSended);

  const onClick = async () => {
    await fetch('/send-email-confirm/?next=' + location.pathname);
    setLinkSent(true);
  };

  const CloseIcon = (
    <DialogClose
      onClick={close}
      className="absolute right-5 top-5 transition-opacity hover:opacity-70 focus:outline-none disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          y1="-1"
          x2="21.2624"
          y2="-1"
          transform="matrix(0.706015 0.708197 -0.706015 0.708197 1 2.35706)"
          stroke="#f8f8fb"
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="21.2624"
          y2="-1"
          transform="matrix(-0.706015 0.708197 0.706015 0.708197 16.7895 2.35706)"
          stroke="#f8f8fb"
          strokeWidth="2"
        />
      </svg>
    </DialogClose>
  );

  return (
    <Dialog open={true} onOpenChange={(open) => !open && close()}>
      <DialogContent
        className="max-w-[600px] w-full bg-[#383a42] p-10 text-[#f8f8fb] rounded-xl border-none shadow-none sm:rounded-xl"
        customCloseIcon={CloseIcon}
      >
        <DialogTitle className="sr-only">
          {linkSent ? t('resendConfirm.linkSent') : t('resendConfirm.message')}
        </DialogTitle>
        <div className="flex flex-col items-center gap-5 text-center font-normal text-[20px]">
          <img className="w-[121px] h-[121px]" src="/static/i/w14.webp" alt="" />
          {!linkSent && (
            <>
              <div
                className="leading-[1.8]"
                dangerouslySetInnerHTML={{ __html: t('resendConfirm.message') }}
              />
              <div
                className="w-[200px] h-[60px] bg-[#00ba88] rounded-lg text-inherit inline-flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-[#00966d]"
                onClick={onClick}
              >
                {t('resendConfirm.resendEmail')}
              </div>
            </>
          )}
          {linkSent && (
            <>
              <div
                className="leading-[1.8]"
                dangerouslySetInnerHTML={{ __html: t('resendConfirm.linkSent') }}
              />
              <div
                className="w-[200px] h-[60px] bg-[#00ba88] rounded-lg text-inherit inline-flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-[#00966d]"
                onClick={close}
              >
                {t('resendConfirm.ok')}
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ResendConfirmAccountNotify;
